import { AppState } from '../types';

export const getPmpState = (state: AppState) => state.pmp;
export const getOhmState = (state: AppState) => state.ohm;
export const getRxEntryState = (state: AppState) => state.rxEntry;
export const getTopConState = (state: AppState) => state.topcon;
export const getAuthState = (state: AppState) => state.auth;
